<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="tvandroid" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Thank you, company
                </div>

                <div>
                  has been successfully changed!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.color"
          @keydown.esc="dialog.color = false"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
            class="pa-2">
            <v-card-title 
              class="d-flex align-center py-0 px-3 text-right popup-header">
              Color Palettes

              <v-spacer/>

              <v-icon 
                @click="dialog.color = false"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text
              class="mt-4">
              <v-color-picker
                v-model="form.color_help"
                width="500"
                dot-size="15"
                mode="hexa"
                show-swatches
                swatches-max-height="100">
              </v-color-picker>
            </v-card-text>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn
                @click="save_color()"
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Save
              </v-btn>

              <v-btn
                @click="dialog.color = false"
                outlined
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize red--text">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Cancel
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Company
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text v-if="process.load && form.config.length < 1">
                  <v-skeleton-loader
                    :loading="process.load"
                    type="article, list-item-two-line, list-item-three-line, article, list-item-two-line">
                  </v-skeleton-loader>

                  <v-row>
                    <v-col
                      cols="12"
                      md="2">
                      <v-skeleton-loader
                        :loading="process.load"
                        type="image">
                      </v-skeleton-loader>
                    </v-col>
                  </v-row>
                </v-card-text>

                <v-card-text v-if="!process.load && form.config.length > 0">
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <ValidationProvider 
                            name="Business Name" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Business Name
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Visuality"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[0].value"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="pb-0">
                          <ValidationProvider 
                            name="Hotline/phone" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Hotline/phone
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : (0274) 2800719"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[12].value"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          class="py-0">
                          <ValidationProvider 
                            name="Address" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Address
                            </div>

                            <v-textarea
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              rows="4"

                              :color="set_color"
                              placeholder="Ex : Jl. Harbour Bay, Sungai Jodoh, Kec. Batu Ampar, Kota Batam, Kepulauan Riau 29444"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[3].value"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <ValidationProvider 
                            name="Email" 
                            rules="required|email" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Email
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : hello@smartiv.com"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[13].value"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <div>
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Check Out Time
                            </div>

                            <v-menu
                              ref="time"
                              v-model="picker.time"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="form.config[14].value"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="290px">
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  name="Check Out Time" 
                                  rules="required"
                                  v-slot="{ errors, valid }">
                                  <v-text-field
                                    v-on:keyup.enter="save()"

                                    readonly
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : 12:00:00"
                                    :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                                    clearable
                                    @click:clear="form.config[14].value = ''"
                                    v-on="on"
                                    v-bind="attrs"

                                    hide-details
                                    
                                    v-model="form.config[14].value"
                                    :success="valid"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </template>

                              <v-time-picker
                                v-if="picker.time"
                                v-model="form.config[14].value"
                                full-width
                                :color="set_color"
                                format="24hr"
                                @click:minute="$refs.time.save(`${form.config[14].value}:00`)">
                              </v-time-picker>
                            </v-menu>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <ValidationProvider 
                            name="Latitude" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Latitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : 1.1524336341448516"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[2].value.latitude"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <ValidationProvider 
                            name="Longitude" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Longitude
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : 103.99886198427828"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[2].value.longitude"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          class="py-0 mb-6">
                          <ValidationProvider 
                            name="Welcome Text" 
                            rules="required|max:2000" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Welcome Text
                            </div>

                            <quill-editor 
                              ref="myTextEditor"
                              :options="{
                                placeholder: 'Ex : Write description in here . . .'
                              }"
                              v-model="form.config[15].value">
                            </quill-editor>

                            <span v-if="form.config[15].value === ''"
                              class="caption red--text">
                              Welcome Text cannot be empty
                            </span>

                            <span v-if="form.config[15].value.length > 2000"
                              class="caption red--text">
                              Welcome Text must not exceed 2000 characters
                            </span>

                            <!-- <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Semoga perjalanan bisnis atau liburan Anda mengesankan bersama kami."
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[15].value"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field> -->
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0">
                          <ValidationProvider 
                            name="WIFI - SSID/Network Name" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <!-- <span class="red--text">*</span> -->

                              WIFI - SSID/Network Name
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Visuality."
                              :append-icon="valid && form.config[16].value.SSID !== '' ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[16].value.SSID"
                              :success="valid && form.config[16].value.SSID !== ''"
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="py-0">
                          <ValidationProvider 
                            name="WIFI - Security" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              WIFI - Security
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : ******"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              :items="[
                                {
                                  text: 'WPA',
                                  value: 'WPA'
                                },
                                {
                                  text: 'WPA2',
                                  value: 'WPA2'
                                },
                                {
                                  text: 'WEP',
                                  value: 'WEP'
                                },
                                {
                                  text: 'Nopass',
                                  value: 'nopass'
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.config[16].value.security = ''"

                              v-model="form.config[16].value.security"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="py-0">
                          <ValidationProvider 
                            name="WIFI - Password" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <!-- <span class="red--text">*</span> -->

                              WIFI - Password
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : ******"
                              :type="show ? 'text' : 'password'"
                              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="show = !show"
                              :counter="20"

                              v-model="form.config[16].value.password"
                              :success="valid && form.config[16].value.password"
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="py-0">
                          <ValidationProvider 
                            name="Text No Internet" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Text No Internet
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Visuality."
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[19].value.title"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="8"
                          class="py-0">
                          <ValidationProvider 
                            name="Content No Internet" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Content No Internet
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : Visuality."
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[19].value.content"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          class="py-0">
                          <ValidationProvider 
                            name="Telegram Group / User (For receive notification)" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">

                              Telegram Group / User (For receive notification)
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              readonly

                              :color="set_color"
                              placeholder="Ex : 6281XXXXXXXX"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.config[17].value.name"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          class="py-0">
                          <v-row>
                            <!-- <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Primary
                                </div>

                                <v-card
                                  @click="to_color('primary', form.config[9].value.primary)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.primary"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.primary }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Background
                                </div>

                                <v-card
                                  @click="to_color('background', form.config[9].value.background)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.background"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.background }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Secondary
                                </div>

                                <v-card
                                  @click="to_color('secondary', form.config[9].value.secondary)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.secondary"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.secondary }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Success
                                </div>

                                <v-card
                                  @click="to_color('success', form.config[9].value.success)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.success"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.success }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Danger
                                </div>

                                <v-card
                                  @click="to_color('danger', form.config[9].value.danger)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.danger"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.danger }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Warning
                                </div>

                                <v-card
                                  @click="to_color('warning', form.config[9].value.warning)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.warning"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.warning }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col> -->

                            <!-- <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Info
                                </div>

                                <v-card
                                  @click="to_color('info', form.config[9].value.info)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.info"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.info }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col> -->

                            <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Light
                                </div>

                                <v-card
                                  @click="to_color('light', form.config[9].value.light)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.light"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.light }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col>

                            <!-- <v-col
                              cols="12"
                              md="2"
                              class="pt-0 pb-6">
                              <div>
                                <div class="body-2 mb-2">
                                  <span class="red--text">*</span>

                                  Dark
                                </div>

                                <v-card
                                  @click="to_color('dark', form.config[9].value.dark)"
                                  flat
                                  class="pa-2"
                                  color="#f0f0f0"
                                  style="border-radius: 10px;">
                                  <v-btn
                                    width="28"
                                    min-width="28"
                                    height="28"
                                    :color="form.config[9].value.dark"
                                    elevation="0"
                                    class="px-0">
                                  </v-btn>

                                  <span
                                    class="ml-2">
                                    {{ form.config[9].value.dark }}
                                  </span>
                                </v-card>
                              </div>
                            </v-col> -->
                          </v-row>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          class="py-0">
                          <v-row>
                            <v-col
                              cols="12"
                              md="3"
                              class="py-0">
                              <div>
                                <ValidationProvider 
                                  name="Food Menu Number Phone" 
                                  v-slot="{ errors, valid }">
                                  <div class="body-2 mb-2">
                                    Food Menu Number Phone
                                  </div>

                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : 081332052369"
                                    :append-icon="valid && form.config[24].value.cta_phone_number !== '' ? 'mdi-check-circle-outline' : ''"

                                    v-model="form.config[24].value.cta_phone_number"
                                    :success="valid && form.config[24].value.cta_phone_number !== ''"
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="7"
                              class="py-0">
                              <div>
                                <ValidationProvider 
                                  name="Food Menu QR Code" 
                                  v-slot="{ errors, valid }">
                                  <div class="body-2 mb-2">
                                    Food Menu QR Code
                                  </div>

                                  <v-text-field
                                    v-on:keyup.enter="save()"
                                    
                                    filled
                                    rounded
                                    dense

                                    :color="set_color"
                                    placeholder="Ex : https://wa.me/6281234567890"
                                    :append-icon="valid && form.config[24].value.cta_qr_url !== '' ? 'mdi-check-circle-outline' : ''"

                                    v-model="form.config[24].value.cta_qr_url"
                                    :success="valid && form.config[24].value.cta_qr_url !== ''"
                                    style="border-radius: 10px;">
                                  </v-text-field>
                                </ValidationProvider>
                              </div>
                            </v-col>

                            <v-col
                              cols="12"
                              md="2"
                              class="py-0">
                              <div>
                                <div class="body-2 mb-2">
                                  Food Menu Status
                                </div>

                                <div>
                                  <v-switch
                                    v-model="form.config[24].value.is_active"
                                    color="success"
                                    class="ma-auto"
                                    hide-details>
                                    <template v-slot:label>
                                      <span class="ml-1 black--text">
                                        {{ form.config[24].value.is_active ? 'Active' : 'Non Active' }}
                                      </span>
                                    </template>
                                  </v-switch>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>

                      <div
                        class="mb-6">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Logo Images
                        </div>

                        <folder v-if="form.config[1].value === ''"
                          v-model="upload.folder">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 10px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.file"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </folder>

                        <v-card v-if="form.config[1].value !== ''"
                          flat
                          color="#BDBDBD"
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 10px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar v-if="!process.file"
                            v-ripple
                            tile 
                            width="200"
                            height="200">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="tvandroid" 
                              :src="form.config[1].value"
                              class="ma-auto">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.config[1].value = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        show: false,

        dialog: {
          success: false,
          color: false
        },

        form: {
          config: [],

          color_type: '',
          color_help: ''
        },

        picker: {
          time: false
        },

        upload: {
          folder: null
        },

        process: {
          load: false,
          form: false,

          file: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      folder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.file = this.upload.folder.process

            if (!this.process.file) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.config[1].value = this.upload.folder.file_url
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch () {
        this.process.load = true

        this.form.config = []

        await get(`admin/config/data`)
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            let data = res.result.data

            data.map(obj => {
              this.form.config.push({
                key: obj.key,
                value: Object.keys(obj.value_object).length > 0 ? obj.value_object : obj.value
              })
            })
          }
        })
      },

      to_color (key, value) {
        this.dialog.color = true

        this.form.color_type = key
        this.form.color_help = value
      },

      save_color () {
        if (this.form.color_type === 'primary') {
          this.form.config[9].value.primary = this.form.color_help.hex
        } else if (this.form.color_type === 'background') {
          this.form.config[9].value.background = this.form.color_help.hex
        } else if (this.form.color_type === 'secondary') {
          this.form.config[9].value.secondary = this.form.color_help.hex
        } else if (this.form.color_type === 'success') {
          this.form.config[9].value.success = this.form.color_help.hex
        } else if (this.form.color_type === 'danger') {
          this.form.config[9].value.danger = this.form.color_help.hex
        } else if (this.form.color_type === 'warning') {
          this.form.config[9].value.warning = this.form.color_help.hex
        } else if (this.form.color_type === 'info') {
          this.form.config[9].value.info = this.form.color_help.hex
        } else if (this.form.color_type === 'light') {
          this.form.config[9].value.light = this.form.color_help.hex
        } else {
          this.form.config[9].value.dark = this.form.color_help.hex
        }

        this.dialog.color = false
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/config/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.success = true

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>